import $http from "../../axios";
import { Notification, MessageBox } from "element-ui";

//Exportar archivo para crear productos.
export async function generateFileExportCsv({ commit, state }) {
  await $http({
    url: `/api/trasportadora-guia-formato`,
    method: "GET",
    responseType: "blob" // important
  }).then(response => {
    var type_file = response.data.type.split("/")[1];

    //Descargar el archivo
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `plantilla-subir-transportadora-guia.${type_file}`);
    document.body.appendChild(link);
    link.click();
  });
}

//Exportar archivo para crear productos.
export async function uploadFileProviderGuides({ commit, state }, data) {
  state.errorFileImport = [];
  commit("setChangeStateLoadFile", true);

  await $http
    .post('/api/importar-transportadora-guia', data.file)
    .then(response => {
      Notification.success({
        title: "Exito!",
        message: response.data.message.text,
        type: "success",
        duration: 1500,
        customClass: "notification-box"
      });
      state.errorFileImport = [];
    })
    .catch(error => {
      console.log(error);
      //setErrorFileImport
      Notification.error({
        title: "Error!",
        message: "Error al importar",
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
      commit("setErrorFileImport", error.response.message);
    });

  commit("setChangeStateLoadFile", false);
}

//Traemos los data sheets
export async function productsDataSheets({ commit, dispatch, state }, id) {
  // commit('clearDataSheets')
  await $http
    .get(`/api/productos-ficha-datos/${id}`)
    .then(response => {
      commit("setProductsDataSheets", response.data);
    })
    .catch(error => {
      Notification.error({
        title: "¡Error!",
        message: error.response.data.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

//Crear una nueva ficha de dato
export async function createProductsDataSheets(
  { commit, state, dispatch },
  data
) {
  await $http
    .post(`/api/ficha-datos-productos/`, data)
    .then(response => {
      Notification.success({
        title: "Exito!",
        message: response.data.message,
        type: "success",
        duration: 1500,
        customClass: "notification-box"
      });
      dispatch("productsDataSheets", data.product_id);
    })
    .catch(error => {
      Notification.error({
        title: "¡Error!",
        message: error.response.data.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

//Actualizar ficha de dato del producto
export async function updateProductsDataSheets(
  { commit, state, dispatch },
  data
) {
  await $http
    .put(`/api/ficha-datos-productos/${data.product_id}`, data.value)
    .then(response => {
      Notification.success({
        title: "Exito!",
        message: response.data.message,
        type: "success",
        duration: 1500,
        customClass: "notification-box"
      });
      dispatch("productsDataSheets", data.product_id);
    })
    .catch(error => {
      Notification.error({
        title: "¡Error!",
        message: error.response.data.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

//Eliminar ficha de dato del producto
export async function deleteProductsDataSheets(
  { commit, state, dispatch },
  data
) {
  await $http
    .delete(
      `/api/ficha-datos-productos/${data.product_id}?data_sheet_id=${data.data_sheet_id}`
    )
    .then(response => {
      Notification.success({
        title: "Exito!",
        message: response.data.message,
        type: "success",
        duration: 1500,
        customClass: "notification-box"
      });
      dispatch("productsDataSheets", data.product_id);
    })
    .catch(error => {
      Notification.error({
        title: "¡Error!",
        message: error.response.data.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

/*
 * Estos metodos se encargar de traer la infromacion para
 * mostrar en la tabla de productos.
 *
 * @author Kevin Galindo
 */
export async function getProductsTable({ commit, state }, data) {
  state.tableProduct.loading = true;

  let params = {
    params: state.tableProduct.options
  };

  await $http
    .get(`/api/tabla-productos/`, params)
    .then(response => {
      commit("setProductsTable", response.data);
    })
    .catch(error => {
      console.error(error);
    });

  state.tableProduct.loading = false;
}

//Este metodo se encarga de guardar un producto.
export async function createProduct({ commit, state }) {
  state.selectedProduct.data_sheets = [];

  state.data_sheets.map(item => {
    state.selectedProduct.data_sheets.push({
      value: item.value,
      data_sheet_id: item.data_sheet_id
    });
  });

  return await new Promise(async (resolve, reject) => {
    await $http
      .post("/api/productos", state.selectedProduct)
      .then(response => {
        Notification.success({
          title: "Exito!",
          message: "El producto ha sido creado",
          type: "success",
          duration: 1500,
          customClass: "notification-box"
        });
        commit("setProduct", response.data.data)
        resolve(response.data.data.id)
      })
      .catch(error => {
        MessageBox.alert('Error en la creación del producto', "Error", {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "Aceptar",
          type: "error",
          customClass: "notification-error"
        });
        reject()
      });
  })


}

//Eliminar productos
export async function deleteProduct({ commit, state }, id) {
  await $http
    .delete(`/api/productos/${id}`)
    .then(response => {
      Notification.success({
        title: "Exito!",
        message: "El producto ha sido eliminado",
        type: "success",
        duration: 1500,
        customClass: "notification-box"
      });
    })
    .catch(error => {
      let data = error.response.data.message
      Notification.error({
        title: "Error!",
        message: "No se pudo eliminar el producto: " + data,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function getParameterByTable({ commit, state }, data) {
  state.parametersByTable = [];
  let response = await $http.get(
    `/api/parametros-por-tabla/${data.paramtable_id}`
  );
  if (response.status == 200) {
    commit("setParametersTableInRow", {
      data: response.data,
      row: data.row,
      paramtable_id: data.paramtable_id
    });
  }
}

export async function fetchLines({ dispatch, state, rootState, commit }) {
  if (!state.lines.length) {
    await dispatch(
      "lines/fetchLines",
      { params: { paginate: false } },
      { root: true }
    );
    commit("setLines", rootState.lines.lines);
  }
}

export async function fetchProviders({ commit }, filter) {
  await $http
    .get("/api/lista-proveedores", filter)
    .then(response => {
      commit("setProviders", response.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function reportGenerate({}) {
  await $http({
    url: "/api/reporte-productos",
    method: "GET",
    responseType: "blob" // important
  })
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "reporte-productos.csv");
      document.body.appendChild(link);
      link.click();
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 3000,
        customClass: "notification-box"
      });
    });
}

export async function getImages({ commit, state }) {
  await $http
    .get(`/api/imagenes-producto/${state.selectedProduct.id}`)
    .then(response => {
      commit('setProductsAttachments', response.data.data)
    })
    .catch(error => {
      let data = error.response.data.message
      Notification.error({
        title: "Error!",
        message: "No se pudo eliminar el producto: " + data,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}


export async function deleteImage({ dispatch, commit, state }, product_attachment_id) {
  await $http
    .delete(`/api/imagenes-producto/${product_attachment_id}`)
    .then(response => {
      Notification.success({
        title: "Exito!",
        message: "La imagen ha sido eliminada",
        type: "success",
        duration: 1500,
        customClass: "notification-box"
      });
      dispatch('getImages')
    })
    .catch(error => {
      let data = error.response.data.message
      Notification.error({
        title: "Error!",
        message: 'Error al eliminar la imagen',
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function setMainToImage({ dispatch, commit, state }, product_attachment_id) {
  await $http
    .put(`/api/imagenes-producto/${product_attachment_id}`)
    .then(response => {
      Notification.success({
        title: "Exito!",
        message: "La imagen principal ha cambiado",
        type: "success",
        duration: 1500,
        customClass: "notification-box"
      });
      dispatch('getImages')
    })
    .catch(error => {
      let data = error.response.data.message
      Notification.error({
        title: "Error!",
        message: 'Error al cambiar la imagen principal',
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}



// WEBPACK FOOTER //
// ./src/modules/protractor-guide/actions.js